import type { ActionToast } from '@tunasong/ui-lib'

/**
 * A task change that didn't go through: offline, or a 412 the server's retries couldn't get past (approved by Brian,
 * 2026-11-02). Try again repeats the same change.
 */
export const taskFailedToast = (retry: () => void): ActionToast => ({
  message: 'Couldn’t update the task. Try again.',
  actionLabel: 'Try again',
  onAction: retry,
  severity: 'error',
})
